import {Component, inject} from '@angular/core';
import {
  ContextMenuButtonComponent
} from "../../../../shared/components/context-menu-button/context-menu-button.component";
import {ContextMenuAction} from "../../../../shared/components/context-menu/context-menu.component";
import {
  TableCustomComponent
} from "../../../../shared/components/data-table/table-custom-component/table-custom.component";
import type {GetTenantListItem} from "../../../../core/api/model";
import {Dialog, DialogRef} from "@angular/cdk/dialog";
import {OverlayService} from "../../../../shared/components/overlay/overlay.service";
import {LinkCompanyToTenantComponent} from "../link-company-to-tenant/link-company-to-tenant.component";

@Component({
  selector: 'app-table-cell-tenant-component',
  imports: [
    ContextMenuButtonComponent
  ],
  templateUrl: './table-cell-tenant-component.component.html',
  styleUrl: './table-cell-tenant-component.component.scss'
})
export class TableCellTenantComponentComponent extends TableCustomComponent<GetTenantListItem> {
  overlayService = inject(OverlayService);

  get tenantActions(): ContextMenuAction[] {
    return [
      {label: 'Link Company', actionKey: 'linkCompany'},
    ];
  }

  handleTenantActions(actionType: string) {
    if (actionType === 'linkCompany') {
      this.linkCompanyToTenant(this.rowData);
    }
  }

  linkCompanyToTenant(tenant: GetTenantListItem) {
    this.overlayService.openModal(LinkCompanyToTenantComponent, {
      data: tenant
    }).closed.subscribe(result => {
    });
  }
}
